import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {Power4} from "gsap/gsap-core";

gsap.registerPlugin(ScrollTrigger, Power4);

const Header = {
    hideMenuOnscroll: true,
    el: null,
    scrollDirection: 1,

    init() {
        this.el = $('[component="Header"]');
        if (!this.el.length) return;

        this.logo = $('[component="Navigation"] [block="logo"]');
        this.page = $('[component="Page"]');
        this.container = this.el.find('[container]');
        this.bind();
        this.bindScroll();
    },

    bind() {
        $('[component="Page"]').click((evt) => {
            evt.stopPropagation();
            this.el.removeClass('hover');
        });

        this.el.click((evt) => {
            $(evt.currentTarget).addClass('hover');
        });

        if (window.innerWidth < 1000) return;

        this.el.mouseover((evt) => {
            $(evt.currentTarget).addClass('hover');
        });

        this.el.mouseout((evt) => {
            $(evt.currentTarget).removeClass('hover');
        });
    },

    bindScroll() {
        ScrollTrigger.create({
            trigger: '[component="Page"]',
            start: "top top",
            end: "bottom bottom",
            scrub: true,
            // markers: true,
            onUpdate: (evt) => {
                if (Math.round(evt.end * evt.progress) > 80) {
                    this.el.addClass('scrolled');
                    $('body').addClass('no-header');
                } else {
                    this.el.removeClass('scrolled');
                    $('body').removeClass('no-header');
                }

                if ((Math.abs(evt.getVelocity()) > 300) && evt.direction !== this.scrollDirection) {
                    if (evt.direction === 1) {
                        this.el.removeClass('visible');
                    } else {
                        this.el.addClass('visible');
                    }

                    this.scrollDirection = evt.direction;
                }
            },
        });
    },

    show() {
        this.el.removeClass('hidden');
    },

    hide() {
        this.el.addClass('hidden');
    },

    showPermanent() {
        this.el.removeClass('hidden_permanent');
    },

    hidePermanent() {
        this.el.addClass('hidden_permanent');
    },

    toggleSubmenu(visible) {
        this.el.find('.sub').toggleClass('hide', !visible);
    },

    destroy() {
        this.el.addClass('destroy');
    },

    open: function () {
        // $('[component="Page"]').attr('menu0pen', '');
        this.el.addClass('open');

        gsap.timeline()
            .to(this.el.find('[block="menu"]'), {y: '0%', duration: 1, ease: Power4.easeOut}, 0)
            .from(this.el.find('[block="menu"] .lang'), {y: '-100%', duration: 2, ease: Power4.easeOut}, 0.4)
            .fromTo(this.el.find('[block="menu"] nav li'),
                {y: '-100%', opacity: 0},
                {y: '0%', opacity: 1, stagger: 0.1, duration: 0.5, overwrite: true, clearProps: true, ease: Power4.easeOut}, 0.3)
    },

    close: function () {
        // $('[component="Page"]').removeAttr('menu0pen');
        this.el.removeClass('open');

        gsap.timeline()
            .to(this.el.find('[block="menu"]'), {y: '-140%', duration: 1, ease: Power4.easeOut}, 0)
    },
}

export default Header;